import React from 'react'
import { Typography } from '@mui/material'
import { formatLongDateNZ } from '../../utils/formatDate'

export interface RoundDeleteItem {
  payload: Record<string, unknown>
  target_round_open_date?: string | null
  target_round_close_date?: string | null
  target_round_estimate_date_flag?: boolean | null
}

/**
 * Produce a one-line summary for a funding_round delete proposed edit.
 *
 * Format: Opens 1 April 2026, closes 30 June 2026
 *
 * Open/close dates are the only disambiguator an admin can act on — the
 * integer round PK is not surfaced anywhere else in the UI (GH#1513).
 * Null/absent dates render as "unknown".
 */
export function roundDeleteSummary(item: RoundDeleteItem): string {
  const open = item.target_round_open_date ?? null
  const close = item.target_round_close_date ?? null
  const openStr = open ? formatLongDateNZ(open) : 'unknown'
  const closeStr = close ? formatLongDateNZ(close) : 'unknown'
  const estimated = item.target_round_estimate_date_flag
    ? ' (estimated dates)'
    : ''
  return `Opens ${openStr}, closes ${closeStr}${estimated}`
}

interface RoundDeleteSummaryProps {
  item: RoundDeleteItem
}

/**
 * Renders a one-line summary for a funding_round delete proposed edit.
 * No diff cells — the summary contains all the information needed for review.
 */
export const RoundDeleteSummary: React.FC<RoundDeleteSummaryProps> = ({
  item,
}) => {
  return (
    <Typography variant="body2">{roundDeleteSummary(item)}</Typography>
  )
}
